exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-e6ce9928]{font-size:64px}", ""]);

// exports
